import * as _ from 'lodash';
import { PipeTransform, Pipe } from '@angular/core';

import { Observable } from 'rxjs';
import { ImageModel } from 'shared/models';

@Pipe({
    name: 'getSafeImageUrl',
    standalone: false
})
export class GetSafeImageUrlPipe implements PipeTransform {
    constructor(private imageModel: ImageModel) {}

    transform(link: string): Observable<string> {
        return this.imageModel.getSafeImageUrl(link);
    }
}
